import { useIsMobile } from "@/hooks/use-mobile";
import { Truck } from "lucide-react";
import OrdersLuijtenVvzTab from "@/components/orders/OrdersLuijtenVvzTab";

const OrdersLuijtenVvz = () => {
  const isMobile = useIsMobile();
  return (
    <div className={isMobile ? "space-y-3" : "space-y-6"}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Truck className={`${isMobile ? "h-5 w-5" : "h-6 w-6"} text-primary`} />
          </div>
          <div>
            <h1 className={`${isMobile ? "text-lg" : "text-2xl"} font-bold`}>Orders Luijten VVZ</h1>
            {!isMobile && (
              <p className="text-muted-foreground">
                Orders met Luijten VVZ als leverancier — pakbonnen en slimme looproute
              </p>
            )}
          </div>
        </div>
      </div>
      <OrdersLuijtenVvzTab />
    </div>
  );
};

export default OrdersLuijtenVvz;
